import { Link } from "react-router-dom";
import { usePageMeta } from "../utils/usePageMeta";

interface Historia {
  slug: string;
  marca: string;
  titol: string;
  resum: string;
  img: string;
  // Logo retallat, sense marge transparent, perquè quedi alineat amb el text
  logo: string;
  capitols: string[];
}

// Cada història és una pàgina pròpia a /histories/<slug>.
const histories: Historia[] = [
  {
    slug: "porsche",
    marca: "Porsche",
    titol: "Del 356 de Gmünd al Taycan",
    resum:
      "Ferdinand i Ferry Porsche, l'escut, les vuit generacions del 911, d'on surten els noms dels models i per què Peugeot va obligar a canviar el 901.",
    img: "/histories/porsche/hero.webp",
    logo: "/histories/porsche/logo.png",
    capitols: ["Orígens", "L'escut", "De qui és", "El 911", "Els noms", "El cas Peugeot", "Models", "Avui"],
  },
];

export const Histories = () => {
  usePageMeta({
    title: "Històries | Cotx.es",
    description: "La història de les marques de cotxes explicada amb fotos: d'on venen, com posen els noms i quins models les han definit.",
  });

  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 sm:px-6 py-8 sm:py-12 max-w-7xl">
        <header className="mb-10 sm:mb-14">
          <h1 className="text-3xl sm:text-5xl font-bold text-foreground tracking-tight">Històries</h1>
          <p className="mt-3 text-muted-foreground max-w-2xl">
            La història de cada marca explicada amb calma: d'on ve, de qui és, com posa els noms als models i quins
            cotxes l'han feta com és.
          </p>
        </header>

        <div className="grid gap-8">
          {histories.map((h) => (
            <Link
              key={h.slug}
              to={`/histories/${h.slug}`}
              className="group relative block overflow-hidden rounded-2xl bg-black text-white"
            >
              <div className="aspect-[4/5] sm:aspect-[21/9]">
                <img
                  src={h.img}
                  alt={h.marca}
                  className="w-full h-full object-cover opacity-90 transition-transform duration-[1200ms] ease-out group-hover:scale-[1.03]"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-6 sm:p-10">
                <div className="flex items-center gap-3 sm:gap-4">
                  <img src={h.logo} alt="" className="h-11 sm:h-[4.5rem] w-auto drop-shadow-lg" />
                  <h2 className="text-4xl sm:text-7xl font-bold tracking-tight">{h.marca}</h2>
                </div>
                <div className="mt-3 text-lg sm:text-2xl font-medium text-white/90">{h.titol}</div>
                <p className="mt-3 text-sm sm:text-base text-white/80 max-w-2xl">{h.resum}</p>
                <div className="mt-5 hidden sm:flex flex-wrap gap-2">
                  {h.capitols.map((c) => (
                    <span key={c} className="text-xs px-2.5 py-1 rounded-md bg-white/10 backdrop-blur-sm">
                      {c}
                    </span>
                  ))}
                </div>
                <div className="mt-5 inline-flex items-center gap-2 text-sm font-medium">
                  Llegeix la història
                  <span className="transition-transform group-hover:translate-x-1">→</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <p className="mt-10 text-sm text-muted-foreground">Aviat, més marques.</p>
      </div>
    </div>
  );
};

export default Histories;
